import { SEO } from '../components/SEO';
import PageHero from '../components/PageHero';
import { SITE } from '../data/site';

const LegalPage = ({ type }) => {
  const isPrivacy = type === 'privacy';
  return (
    <>
      <SEO
        title={isPrivacy ? 'Privacy Policy | Nebraska Backyard Living' : 'Terms & Conditions | Nebraska Backyard Living'}
        description={isPrivacy ? 'How Nebraska Backyard Living collects, uses, and protects your information.' : 'Terms and conditions for using the Nebraska Backyard Living website.'}
        path={isPrivacy ? '/privacy-policy/' : '/terms/'}
      />
      <PageHero
        overline="Legal"
        title={isPrivacy ? 'Privacy Policy' : 'Terms & Conditions'}
        breadcrumbs={[{ name: 'Home', path: '/' }, { name: isPrivacy ? 'Privacy Policy' : 'Terms & Conditions' }]}
        compact
      />
      <section className="py-16 md:py-20">
        <div className="container-site max-w-3xl space-y-8 text-base leading-relaxed text-muted2">
          {isPrivacy ? (
            <>
              <p><strong className="text-ink">Last updated:</strong> July 2026</p>
              <h2 className="font-serif text-2xl font-medium text-ink">Information We Collect</h2>
              <p>When you request a quote or contact us through this website, we collect the information you provide — such as your name, email address, phone number, property city, and project details — solely for the purpose of responding to your inquiry and providing our services.</p>
              <h2 className="font-serif text-2xl font-medium text-ink">How We Use Your Information</h2>
              <p>We use your information to contact you about your project, schedule consultations, and deliver the services you request. We do not sell, rent, or share your personal information with third parties for their marketing purposes.</p>
              <h2 className="font-serif text-2xl font-medium text-ink">Data Security</h2>
              <p>We take reasonable measures to protect the information you share with us. No method of transmission over the internet is 100% secure, but we treat your information with the same care we bring to our projects.</p>
              <h2 className="font-serif text-2xl font-medium text-ink">Questions</h2>
              <p>Questions about this policy? Contact us at {SITE.email} or {SITE.phone}.</p>
            </>
          ) : (
            <>
              <p><strong className="text-ink">Last updated:</strong> July 2026</p>
              <h2 className="font-serif text-2xl font-medium text-ink">Use of This Website</h2>
              <p>This website is provided by {SITE.name} ({SITE.legalName}) for general information about our outdoor living design and construction services. Content may be updated or changed at any time without notice.</p>
              <h2 className="font-serif text-2xl font-medium text-ink">Estimates & Consultations</h2>
              <p>Information on this website does not constitute a binding quote. All pricing is provided following an on-site consultation and is specific to your project scope, site conditions, and material selections.</p>
              <h2 className="font-serif text-2xl font-medium text-ink">Intellectual Property</h2>
              <p>All text, imagery, and design on this website are the property of {SITE.name} or their respective owners and may not be reproduced without permission.</p>
              <h2 className="font-serif text-2xl font-medium text-ink">Contact</h2>
              <p>Questions about these terms? Contact us at {SITE.email} or {SITE.phone}.</p>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default LegalPage;
